export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  cpfCnpj: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  rg: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  cnh: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  address: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  addressNumber: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  complement: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  district: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  },
  zipcode: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  stateID: {
    value: null,
    options: [],
    clearOption: false,
    required: true,
    state: null
  },
  cityID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null
  },
  phoneNumber: {
    value: '',
    maxlength: '15',
    required: false,
    state: null
  },
  cellNumber: {
    value: '',
    maxlength: '15',
    required: false,
    state: null
  },
  email: {
    value: '',
    maxlength: '70',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/insured/insured-form.js